import { Component, OnInit } from '@angular/core';
import { Message } from '@model/Message';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '@service/auth.service';
import { DevelopmentService } from '@service/development.service';
import { UtilService } from '@service/util.service';
import * as Bib2Json from "bib2json";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-view-bibtex',
  templateUrl: './modal-view-bibtex.component.html',
  styleUrls: ['./modal-view-bibtex.component.scss']
})
export class ModalViewBibtexComponent implements OnInit {

  searchStringId: number;
  name: string;
  bibtex: string;
  studiesIds: number[] = [];
  loading = false;

  constructor(
    private developmentService: DevelopmentService,
    private utilService: UtilService,
    public activeModal: NgbActiveModal,
    private authService: AuthService,
    private toast: ToastrService
  ) { }

  ngOnInit() {
    this.loading = true
    this.developmentService
      .exportStudies(this.searchStringId, "bibtex")
      .subscribe((studies) => {
        let bibContent = "";

        studies.forEach((study, idx) => {
          this.studiesIds.push(study.id)
          let document_type = study.columns.document_type
            ? study.columns.document_type
            : "article";
          document_type = document_type.replace(
            /CONFERENCE PAPER/i,
            "conference"
          );
          document_type = document_type.replace(/BOOK CHAPTER/i, "inbook");
          document_type = document_type.replace(/REVIEW/i, "misc");
          bibContent += `@${document_type.split(" ")[0]}{${
            study.columns.year
              ? study.columns.year
              : this.utilService.slugify(study.columns.title)
          }${idx}`;
          bibContent += study.columns.title
            ? `,\n\ttitle="${study.columns.title}"`
            : "";
          bibContent += study.columns.author
            ? `,\n\tauthor="${study.columns.author}"`
            : "";
          bibContent += study.columns.isbn
            ? `,\n\tisbn="${study.columns.isbn}"`
            : "";
          bibContent += study.columns.journal
            ? `,\n\tjournal="${study.columns.journal}"`
            : "";
            bibContent += study.columns.doi
            ? `,\n\tdoi="${study.columns.doi}"`
            : "";
          bibContent += study.columns.url
            ? `,\n\turl="${study.columns.url}"`
            : "";
          bibContent += study.columns.publisher
            ? `,\n\tpublisher="${study.columns.publisher}"`
            : "";
          bibContent += study.columns.year
            ? `,\n\tyear="${study.columns.year}"`
            : "";
          bibContent += study.columns.abstract
            ? `,\n\tabstract="${study.columns.abstract}"`
            : "";
          bibContent += study.columns.pages
            ? `,\n\tpages="${study.columns.pages}"`
            : "";
          bibContent += study.columns.volume
            ? `,\n\tvolume="${study.columns.volume}"`
            : "";
          bibContent += "\n\t}\n";
          this.loading = false
        });

        this.bibtex = bibContent;
      });
  }

  onSubmit() {
    console.log(this.bibtex)
    const { entries } = Bib2Json(this.bibtex);
    if (entries.length) {
      for (let i = 0; i < entries.length; i++) {
        entries[i].Fields.average_quality_answers = -1;
        entries[i].Fields.rejectedOnSelectStudies = null;
        entries[i].id = this.studiesIds[i] ? this.studiesIds[i] : null
      }

      this.developmentService
        .bulkIncrementBibtexSelectedStudies({
          development_search_string_id: this.searchStringId,
          ...this.utilService.bibtextEntriesToSelectedStudies(
            entries,
            this.authService.user.name
          ),
        })
        .subscribe(() => {
          this.toast.success(Message.SUCCESS);
        });
    } else {
      this.toast.error("O conteúdo BibTeX fornecido não é válido!");
    }
    this.activeModal.close();
    this.loading = false;
  }
}
